import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import DefaultLayout from "./Components/Layout/DefaultLayout";
import Login from "./Page/Auth/Login";
import React from "react";
import Registration from "../src/Page/Auth/Registration";
import FinalRegistration from "../src/Page/Auth/FinalRegistration";
import VerifyOtp from "../src/Page/Auth/VerifyOtp";
import Dashboard from "./Page/ToolCategory";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/registration" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/final-registration" element={<FinalRegistration />} />
          <Route path="*" element={<DefaultLayout />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
